module.exports = __webpack_public_path__ + "img/Carousel-funcionalidades-icono-06.e3b16f78.svg";